import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AuthenticationFacade } from '@planone/bau365/data-access-authentication';
import * as DataAccessFairData from '@planone/bau365/data-access-fair-data';
import * as FeatureTrackingGoogleAnalytics from '@planone/shared/feature-tracking-google-analytics';
import * as FeatureTrackingSnowplow from '@planone/shared/feature-tracking-snowplow';
import { localizedMeta, MetaService } from '@planone/shared/util-meta';
import { of, switchMap, withLatestFrom } from 'rxjs';

import { CustomEventIglu } from '../../tracking-types/snowplow/schema/schema.interface';

@Injectable()
export class FairsEffects {
  pageView$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DataAccessFairData.fairsPageOpened),
      withLatestFrom(this.authenticationFacade.excludeAnalytics$),
      switchMap(([_, exclude_analytics]) => {
        return of(
          FeatureTrackingSnowplow.pageView({
            title: this.metaService.getTitle(localizedMeta['titleFairDetails']),
            context: [
              {
                schema: CustomEventIglu.page_view,
                data: {
                  context: 'cross-fair',
                  page_type: 'fair-details',
                  exclude_analytics: exclude_analytics,
                },
              },
            ],
          }),
          FeatureTrackingGoogleAnalytics.push({
            event: 'pageview',
            context: 'cross-fair',
            page_type: 'fair-details',
            exclude_analytics: exclude_analytics,
          })
        );
      })
    )
  );

  constructor(
    private readonly actions$: Actions,
    private authenticationFacade: AuthenticationFacade,
    private metaService: MetaService
  ) {}
}
